const url = new URL(document.currentScript.src);
/* eslint-disable camelcase */
__webpack_public_path__ = `${url.href.split('/js')[0]}/${__webpack_public_path__}`;
